import React, { PureComponent } from 'react';

import { CardIcon } from '../CardIcon/CardIcon';
import classNames from 'classnames/bind';
import styles from './SmartCardIcon.scss';
const cx = classNames.bind(styles);

class SmartCardIcon extends PureComponent {
  constructor(props, ctx) {
    super(props, ctx);
  }

  getCardIcon(cardType) {}

  render() {
    const { type } = this.props;

    return (
      <span
        className={cx('SmartCardIcon', {
          [`${type}`]: Boolean(type),
        })}
      >
        <CardIcon type={type} />
      </span>
    );
  }
}

export default SmartCardIcon;
